import React, { ReactElement } from 'react';
import { Trans, useTranslation } from 'next-i18next';

import Button from '@Hotels-at-Home/hah-fe-core/dist/components/Button';
import TitleFlip from '../../helpers/TitleFlip';

const RobesSection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$robesSection' });
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
  const { t: tCommon } = useTranslation('', { keyPrefix: '$common' });
  const { t: tLink } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$robes' });

  return (
    <section className="base-section robes-section bedding-section bedding robes">
      <div className="branding-hero desktop-viewport">
        <p className="brand-copy txt" data-gsap="fade-up" data-gsap-delay="0.5">
          <Trans i18nKey="wrapYourself" t={t} components={{ span: <span /> }} />
        </p>
        <a href={tLink('robes')} aria-label={t('robes')}>
          <div className="img-wrap-tall">
            <picture>
              <source srcSet="/images/homePage/fill.gif" media="(max-width: 800px)" />
              <source srcSet="/images/homePage/robesSection/robes-background.webp" />
              <img
                data-gsap="zoom-out"
                data-gsap-delay="0.03"
                src="/images/homePage/robesSection/robes-background.webp"
                alt={t('marriottRobes')}
                loading="lazy"
                width="849"
                height="923"
                decoding="async"
                fetchPriority="low"
              />
            </picture>
            <div className="cinema-gif">
              <picture>
                <source srcSet="/images/homePage/fill.gif" media="(max-width: 800px)" />
                <img
                  data-gsap="zoom-out"
                  src="/images/homePage/robesSection/robes-overlay.gif"
                  alt={t('marriottRobes')}
                  loading="lazy"
                  width="849"
                  height="923"
                  decoding="async"
                  fetchPriority="low"
                />
              </picture>
            </div>
          </div>
        </a>
      </div>
      <div className="outer-wrap desktop-viewport">
        <div className="inner-wrap" data-gsap="fade" data-gsap-delay="0.03">
          <div className="title">
            <h2 data-gsap="fade-up" data-gsap-delay="0.6" className="section-title">
              <TitleFlip normalText={t('marriott')}>
                <span className="accent-bar">
                  {t('robes')}
                  <em data-gsap="grow" data-gsap-delay="1" data-gsap-duration="0.8" />
                </span>
              </TitleFlip>
            </h2>
          </div>

          <div className="bedding-products">
            <a
              className="bedding-product-wrap hover-btn-animation"
              href={tLink('microfiberRobe')}
              id="btn_HP_microfiber_robe"
            >
              <picture>
                <source srcSet="/images/homePage/fill.gif" media="(max-width: 800px)" />
                <source srcSet="/images/homePage/robesSection/hp-microfiber-robe.webp" />
                <img
                  data-gsap="fade"
                  data-gsap-delay="0.4"
                  src="/images/homePage/robesSection/hp-microfiber-robe.webp"
                  alt={tCommon('productName', { productName: t('microfiberRobe') })}
                  loading="lazy"
                  width="755"
                  height="787"
                  decoding="async"
                  fetchPriority="low"
                />
              </picture>
              <h3 className="section-subtitle">
                <span data-gsap="fade-left" data-gsap-delay="0.6">
                  {t('microfiberRobe')}
                </span>
              </h3>
              <div className="hover-content">
                <Button noTabbing ariaLabel={`${tButton('shopNow')}: ${t('microfiberRobe')}`}>
                  {tButton('shopNow')}
                </Button>
              </div>
            </a>
            <a
              className="bedding-product-wrap hover-btn-animation"
              href={tLink('terryVelourRobe')}
              id="btn_HP_terry_robe"
            >
              <picture>
                <source srcSet="/images/homePage/fill.gif" media="(max-width: 800px)" />
                <source srcSet="/images/homePage/robesSection/hp-terry-robe.webp" />
                <img
                  data-gsap="fade"
                  data-gsap-delay="0.4"
                  src="/images/homePage/robesSection/hp-terry-robe.webp"
                  alt={tCommon('productName', { productName: t('terryVelourRobe') })}
                  loading="lazy"
                  width="755"
                  height="787"
                  decoding="async"
                  fetchPriority="low"
                />
              </picture>
              <h3 className="section-subtitle">
                <span data-gsap="fade-left" data-gsap-delay="0.6">
                  {t('terryVelourRobe')}
                </span>
              </h3>
              <div className="hover-content">
                <Button noTabbing ariaLabel={`${tButton('shopNow')}: ${t('terryVelourRobe')}`}>
                  {tButton('shopNow')}
                </Button>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RobesSection;
